import {http} from "./http.js";
import  router from '@/router';

export function acceso(codLocal,passLocal){
  

    let data = {
        codLocal : codLocal,
        passLocal : passLocal
    };

    console.log(data);

    return http().post('/sucursal/acceso', data)
}

export function listarSucursal(companyid){

    return http().post('/sucursal/indexby', companyid);
}

export function validate_status(){

   let sucursal = JSON.parse(localStorage.getItem('active_sucursal'))

   console.log(sucursal);

   if(!sucursal){
        router.push('/preview')
        console.log('seleccionar sucursal');
   }else if( router.currentRoute.value.fullPath == '/preview'){
        router.push('/guias')
   }

   

}